import React from 'react';
import { projectStatusMeta } from '../../lib/projects';

export default function ProjectStatusChip({ status, className = '' }) {
  const meta = projectStatusMeta(status);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium uppercase tracking-wider border ${meta.tone} ${className}`}>
      {meta.label}
    </span>
  );
}
